// src/pages/Unauthorized.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 text-gray-800 p-6">
      <div className="bg-white p-10 rounded-xl shadow-lg text-center max-w-md">
        <FontAwesomeIcon icon={faLock} size="4x" className="text-red-500 mb-4" />
        <h1 className="text-3xl font-bold mb-4">Unauthorized Access</h1>
        <p className="text-gray-600 mb-6">
          You do not have the necessary permissions to access this page.
          Please contact your administrator if you believe this is a mistake.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
          Go Back
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;